module.exports = __webpack_public_path__ + "img/menu.37a26e1e.svg";